module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/question-a7ef6d717450e1880b7cb9450b7bedd5.svg";